function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Payment
 * 
 */
import React from 'react';
import { connect } from 'react-redux';
import { COSTS } from '../../data/Data';
import './PaymentText.scss';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export class PaymentText extends React.Component {
  render() {
    const {
      application,
      postage
    } = this.props;
    const price = (postage.cost + COSTS.permit).toFixed(2);
    return /*#__PURE__*/_jsx("div", {
      className: "PaymentText",
      children: /*#__PURE__*/_jsxs("p", {
        children: ["Your credit card will be charged ", /*#__PURE__*/_jsxs("strong", {
          children: ["$", price]
        }), " by ", application.club.abbreviation, " for the purchase of an International Driver Permit."]
      })
    });
  }
}
_defineProperty(PaymentText, "defaultProps", {
  application: {
    club: {
      abbreviation: 'RAA'
    }
  },
  postage: {
    description: 'Express Post within Australia',
    cost: 11.75,
    value: 'express_post'
  }
});
const mapStateToProps = ({
  application,
  postage
}) => {
  return {
    application,
    postage
  };
};
const VisiblePaymentText = connect(mapStateToProps)(PaymentText);
export default VisiblePaymentText;